import React, { useCallback } from 'react';
import Button from '../Button';
import { NavbarContent } from './styles';
import { useModal } from '../../hooks/modal';
import { SITE_TITLE, URL_LINK_AME, URL_LINK_LASA, URL_LINK_LETS } from '../../constants';

const Navbar: React.FC = () => {
  const { handleModal } = useModal();

  const isCurrentBrand = (title: string): boolean => SITE_TITLE === title;

  const openModal = useCallback(() => {
    handleModal({ isOpen: true, action: 'signin' });
  }, []);

  return (
    <NavbarContent>
      <nav className="navbar is-transparent" role="navigation" aria-label="main-navigation">
        <div className="container">
          <div className="navbar-brand">
            <a href={URL_LINK_LASA} className="navbar-item" title="americanas s.a.">
              <img
                className={`${isCurrentBrand('americanas s.a.') ? 'main-brand' : ''}`}
                src={'img/brands/americanas.png'}
                alt="Americanas SA"
              />
            </a>
            <a href={URL_LINK_AME} className="navbar-item" title="Ame">
              <img className={`${isCurrentBrand('Ame') ? 'main-brand' : ''}`} src={'img/brands/ame.svg'} alt="Ame" />
            </a>
          </div>
          <div className="btn-mobile">
            <div className="navbar-end has-text-centered is-flex">
              <span className="icon">
                <img src={'img/logo-allya-w.svg'} alt="Allya" />
              </span>
              <Button title="Entrar" classType="center outline-blue navbtn" onClick={openModal} />
            </div>
          </div>
          <div className="navbar-menu">
            <div className="navbar-end has-text-centered">
              <span className="icon">
                <img src={'img/logo-allya-w.svg'} alt="Allya" />
              </span>
              <Button title="Entrar" classType="center navbtn" onClick={openModal} />
            </div>
          </div>
        </div>
      </nav>
    </NavbarContent>
  );
};

export default Navbar;
